import {
  getColEndByDate,
  getColStartByDate,
} from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/utils/columnHelpers';

export class Interval {
  constructor({ von, bis }: { von: Date; bis: Date }) {
    this.von = von;
    this.bis = bis;
  }

  von: Date;
  bis: Date;

  getColStart(displayYear: number): number {
    return getColStartByDate(displayYear, this.von);
  }

  getColEnd(displayYear: number): number {
    return getColEndByDate(displayYear, this.bis);
  }
}
